import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="currency-conversion"
export default class extends Controller {
  static values = {
    exchangeRate: Number,
  };

  static targets = [
    "basicBasePriceEUR",
    "basicBasePriceCZK",
    "premiumBasePriceEUR",
    "premiumBasePriceCZK",
    "vipBasePriceEUR",
    "vipBasePriceCZK",
    "eliteBasePriceEUR",
    "eliteBasePriceCZK",

    "basicSalePriceEUR",
    "basicSalePriceCZK",
    "premiumSalePriceEUR",
    "premiumSalePriceCZK",
    "vipSalePriceEUR",
    "vipSalePriceCZK",
    "eliteSalePriceEUR",
    "eliteSalePriceCZK",

    "basicBulkPriceEUR",
    "basicBulkPriceCZK",
    "premiumBulkPriceEUR",
    "premiumBulkPriceCZK",
    "vipBulkPriceEUR",
    "vipBulkPriceCZK",
    "eliteBulkPriceEUR",
    "eliteBulkPriceCZK",

    "basicRoundedCornerPriceEUR",
    "basicRoundedCornerPriceCZK",
    "premiumRoundedCornerPriceEUR",
    "premiumRoundedCornerPriceCZK",
    "vipRoundedCornerPriceEUR",
    "vipRoundedCornerPriceCZK",
    "eliteRoundedCornerPriceEUR",
    "eliteRoundedCornerPriceCZK",
  ];

  connect() {
    this.inputEvent = new Event("input");

    if (this.hasBasicBasePriceEURTarget && this.hasBasicBasePriceCZKTarget) {
      this.basicBasePriceEURTarget.addEventListener("input", () => {
        this.basicBasePriceCZKTarget.value =
          this.basicBasePriceEURTarget.value * this.exchangeRateValue;
        this.basicBasePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for basic price.");
    }

    if (this.hasBasicSalePriceEURTarget && this.hasBasicSalePriceCZKTarget) {
      this.basicSalePriceEURTarget.addEventListener("input", () => {
        this.basicSalePriceCZKTarget.value =
          this.basicSalePriceEURTarget.value * this.exchangeRateValue;
        this.basicSalePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for basic price.");
    }

    if (this.hasBasicBulkPriceEURTarget && this.hasBasicBulkPriceCZKTarget) {
      this.basicBulkPriceEURTarget.addEventListener("input", () => {
        this.basicBulkPriceCZKTarget.value =
          this.basicBulkPriceEURTarget.value * this.exchangeRateValue;
        this.basicBulkPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for basic bulk price.");
    }

    if (
      this.hasBasicRoundedCornerPriceEURTarget &&
      this.hasBasicRoundedCornerPriceCZKTarget
    ) {
      this.basicRoundedCornerPriceEURTarget.addEventListener("input", () => {
        this.basicRoundedCornerPriceCZKTarget.value =
          this.basicRoundedCornerPriceEURTarget.value * this.exchangeRateValue;
        this.basicRoundedCornerPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.info("Rounded corner price for Basic role not available");
    }

    if (
      this.hasPremiumBasePriceEURTarget &&
      this.hasPremiumBasePriceCZKTarget
    ) {
      this.premiumBasePriceEURTarget.addEventListener("input", () => {
        this.premiumBasePriceCZKTarget.value =
          this.premiumBasePriceEURTarget.value * this.exchangeRateValue;
        this.premiumBasePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for premium price.");
    }

    if (
      this.hasPremiumSalePriceEURTarget &&
      this.hasPremiumSalePriceCZKTarget
    ) {
      this.premiumSalePriceEURTarget.addEventListener("input", () => {
        this.premiumSalePriceCZKTarget.value =
          this.premiumSalePriceEURTarget.value * this.exchangeRateValue;
        this.premiumSalePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for premium price.");
    }

    if (
      this.hasPremiumBulkPriceEURTarget &&
      this.hasPremiumBulkPriceCZKTarget
    ) {
      this.premiumBulkPriceEURTarget.addEventListener("input", () => {
        this.premiumBulkPriceCZKTarget.value =
          this.premiumBulkPriceEURTarget.value * this.exchangeRateValue;
        this.premiumBulkPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for premium bulk price.");
    }

    if (
      this.hasPremiumRoundedCornerPriceEURTarget &&
      this.hasPremiumRoundedCornerPriceCZKTarget
    ) {
      this.premiumRoundedCornerPriceEURTarget.addEventListener("input", () => {
        this.premiumRoundedCornerPriceCZKTarget.value =
          this.premiumRoundedCornerPriceEURTarget.value *
          this.exchangeRateValue;
        this.premiumRoundedCornerPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.info("Rounded corner price for Premium role not available");
    }

    if (this.hasVipBasePriceEURTarget && this.hasVipBasePriceCZKTarget) {
      this.vipBasePriceEURTarget.addEventListener("input", () => {
        this.vipBasePriceCZKTarget.value =
          this.vipBasePriceEURTarget.value * this.exchangeRateValue;
        this.vipBasePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for vip price.");
    }

    if (this.hasVipSalePriceEURTarget && this.hasVipSalePriceCZKTarget) {
      this.vipSalePriceEURTarget.addEventListener("input", () => {
        this.vipSalePriceCZKTarget.value =
          this.vipSalePriceEURTarget.value * this.exchangeRateValue;
        this.vipSalePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for vip price.");
    }

    if (this.hasVipBulkPriceEURTarget && this.hasVipBulkPriceCZKTarget) {
      this.vipBulkPriceEURTarget.addEventListener("input", () => {
        this.vipBulkPriceCZKTarget.value =
          this.vipBulkPriceEURTarget.value * this.exchangeRateValue;
        this.vipBulkPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for vip bulk price.");
    }

    if (
      this.hasVipRoundedCornerPriceEURTarget &&
      this.hasVipRoundedCornerPriceCZKTarget
    ) {
      this.vipRoundedCornerPriceEURTarget.addEventListener("input", () => {
        this.vipRoundedCornerPriceCZKTarget.value =
          this.vipRoundedCornerPriceEURTarget.value * this.exchangeRateValue;
        this.vipRoundedCornerPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.info("Rounded corner price for Vip role not available");
    }

    if (this.hasEliteBasePriceEURTarget && this.hasEliteBasePriceCZKTarget) {
      this.eliteBasePriceEURTarget.addEventListener("input", () => {
        this.eliteBasePriceCZKTarget.value =
          this.eliteBasePriceEURTarget.value * this.exchangeRateValue;
        this.eliteBasePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for elite price.");
    }

    if (this.hasEliteSalePriceEURTarget && this.hasEliteSalePriceCZKTarget) {
      this.eliteSalePriceEURTarget.addEventListener("input", () => {
        this.eliteSalePriceCZKTarget.value =
          this.eliteSalePriceEURTarget.value * this.exchangeRateValue;
        this.eliteSalePriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for elite price.");
    }

    if (this.hasEliteBulkPriceEURTarget && this.hasEliteBulkPriceCZKTarget) {
      this.eliteBulkPriceEURTarget.addEventListener("input", () => {
        this.eliteBulkPriceCZKTarget.value =
          this.eliteBulkPriceEURTarget.value * this.exchangeRateValue;
        this.eliteBulkPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.error("Missing targets for elite price.");
    }

    if (
      this.hasEliteRoundedCornerPriceEURTarget &&
      this.hasEliteRoundedCornerPriceCZKTarget
    ) {
      this.eliteRoundedCornerPriceEURTarget.addEventListener("input", () => {
        this.eliteRoundedCornerPriceCZKTarget.value =
          this.eliteRoundedCornerPriceEURTarget.value * this.exchangeRateValue;
        this.eliteRoundedCornerPriceCZKTarget.dispatchEvent(this.inputEvent);
      });
    } else {
      console.info("Rounded corner price for Elite role not available");
    }
  }

  perform(eur, czk) {
    return eur * czk;
  }
}
